import { mapActions } from 'vuex';

export default {
  data() {
    return {
      privileges: new Set(),
    };
  },
  computed: {
    showLocations() {
      return this.privileges.has('DRMCH') || this.privileges.has('PRSID') || this.privileges.has('LOCID');
    },
    showMatchTypes() {
      return this.privileges.has('DRMCH');
    },
    showGroups() {
      return this.privileges.has('LOCID');
    },
  },
  methods: {
    ...mapActions([
      'getPrivileges',
    ]),
    async hasRolePermissions(roleId) {
      try {
        const res = await this.getPrivileges(roleId);
        this.privileges = new Set(res.data.flatMap(p => p.permissions)
          .flatMap(p => p.appModules)
          .filter(m => m.enabled)
          .map(m => m.code));
      } catch (error) {
        this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        this.showError(this.apiMsg);
      }
    },
  },
};
